$('document').ready(function() {
	var videoSrc, posterSrc;
	$('.video-btn').each(function() {
		$(this).wrap('<div class="card"></div>');
		$(this).addClass('card-img');
		$(this).append('<div class="card-img-overlay text-center"><img src="/images/frontend/icon/play.png" style="max-width:70%; max-height:70%;vertical-align: middle;"></div>');

	});
	$('.video-btn').click(function() {
		var video = $('#videoModal video')[0];
		videoSrc = $(this).data("src");
		posterSrc = $(this).data("poster");
		$('#videoModal').modal();
		setTimeout(function () { $(video).load(function () { video.play(); }); }, 500);
	});

	$('#videoModal').on('shown.bs.modal', function (e) {
		$(this).find('video source').attr('src', videoSrc + "");

		var video = $(this).find('video')[0];
		video.load();
		video.play();
	})
	$('#videoModal').on('hidden.bs.modal', function (e) {
		var video = $(this).find('video')[0];
		video.pause();
		$(this).find('video source').attr('src', videoSrc);
	})

	$('.button-calendly-inline').on('click', function (e) {
		e.preventDefault();
		var link = $(this).attr('href');
		Calendly.showPopupWidget(link || 'https://calendly.com/woodler');
		return false;
	})
});
